"use client";
import { useStore } from "../../../../../service/mobx";
import ButtonFilled from "../../../../../component/Button/Filled";

function RunButton({
  label,
  disabled,
  isOnApiPlan,
  allowed,
  modelSize,
  IconEnd,
  runModel,
  ...props
}) {
  // observer not required, we just want to use the .notify() method
  const { snackbar } = useStore();

  return (
    <ButtonFilled
      label={label}
      disabled={disabled}
      IconEnd={IconEnd}
      href={
        isOnApiPlan
          ? undefined
          : `/api?returnTo=${encodeURIComponent(window.location.href)}`
      }
      onClick={
        allowed && !disabled
          ? runModel
          : () => {
              if (!isOnApiPlan) {
                return;
              }

              snackbar.notify({
                text: `This model requires the "${modelSize?.toUpperCase()}" plan`,
                actions: [
                  {
                    label: "Upgrade",
                    href: `/api?returnTo=${encodeURIComponent(
                      window.location.href
                    )}`,
                    // make sure the notification closes when we navigate
                    onClick: snackbar.reset
                  }
                ]
              });
            }
      }
      {...props}
    />
  );
}

export default RunButton;
